import { LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import NormalInput from '../../inputs/normalInput';

const ChangePasswordStep = (props) => {
  const [state, setState] = useState({});

  const onSubmit = () => {
    props.onSubmit();
  };

  const onForgotPasswordClick = () => {
    props.onForgotPasswordClick();
  };
  return (
    <form className="change-password" onSubmit={onSubmit}>
      <NormalInput
        name="currentPassword"
        title="Current password"
        type="password"
        isRequired
        isUseForm
        control={props.form?.control}
        placeholder="Current password"
        errMsg={props.form?.formState?.errors?.currentPassword?.message}
      />
      <NormalInput
        className="mt-10"
        name="newPassword"
        title="New password"
        type="password"
        isRequired
        isUseForm
        control={props.form?.control}
        placeholder="New password"
        errMsg={props.form?.formState?.errors?.newPassword?.message}
      />
      <p onClick={onForgotPasswordClick} className="forgot-password">
        Forgot password
        {' '}
        {props.forgotPasswordLoading && <LoadingOutlined />}
      </p>
    </form>
  );
};

ChangePasswordStep.defaultProps = {
  form: {},
  forgotPasswordLoading: false,

  onSubmit: () => {},
  onForgotPasswordClick: () => {},
};

ChangePasswordStep.propTypes = {
  form: PropTypes.shape({}),
  forgotPasswordLoading: PropTypes.bool,

  onSubmit: PropTypes.func,
  onForgotPasswordClick: PropTypes.func,
};

export default ChangePasswordStep;
